import Const from "../../utils/constant";

const RenderImage = ({ keyField, src, alt, className, style }) => {
    // Determine the base URL for images. If keyField is present, use the API proxy.
    const imageUrl = keyField ? `${Const.API.API_BASE_URL}/file/file-content?file_url=${keyField}` : src;

    return (
        <img 
            src={imageUrl || "/assets/image/placeholder.png"} 
            alt={alt} 
            className={className} 
            style={style}
            onError={(e) => {
                e.target.src = "/assets/image/placeholder.png";
            }}
        />
    );
};

export default RenderImage;
